import { render, staticRenderFns } from "./select-mortgage-type.vue?vue&type=template&id=66fd84dc"
import script from "./select-mortgage-type.vue?vue&type=script&lang=ts"
export * from "./select-mortgage-type.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports